import { useEffect, useRef, useState } from "react";

/* Barra de acción fija al pie, solo en móvil (<768px). Publica su altura en --tf-actionbar-h
   para que cookies, FABs y el body se eleven. Se oculta cuando `hideWhenVisible` entra en pantalla. */
export const MobileActionBar = ({ children, hideWhenVisible, testid = "mobile-action-bar" }) => {
  const ref = useRef(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!hideWhenVisible) return undefined;
    const target = document.querySelector(hideWhenVisible);
    if (!target || typeof IntersectionObserver === "undefined") return undefined;
    const io = new IntersectionObserver(([e]) => setHidden(e.isIntersecting), { threshold: 0.35 });
    io.observe(target);
    return () => io.disconnect();
  }, [hideWhenVisible]);

  useEffect(() => {
    const root = document.documentElement;
    const mq = window.matchMedia("(max-width: 767px)");
    const measure = () => {
      const h = !hidden && mq.matches ? ref.current?.offsetHeight || 0 : 0;
      root.style.setProperty("--tf-actionbar-h", `${h}px`);
    };
    measure();
    window.addEventListener("resize", measure);
    return () => { window.removeEventListener("resize", measure); root.style.setProperty("--tf-actionbar-h", "0px"); };
  }, [hidden]);

  return (
    <div ref={ref} data-testid={testid} aria-hidden={hidden}
      className={`md:hidden fixed inset-x-0 bottom-0 z-[45] border-t border-slate-200 bg-white/95 backdrop-blur px-4 pt-2.5 shadow-[0_-8px_24px_rgba(19,49,92,0.08)] transition-transform duration-300 ${hidden ? "translate-y-full pointer-events-none" : "translate-y-0"}`}
      style={{ paddingBottom: "calc(0.625rem + env(safe-area-inset-bottom, 0px))" }}>
      {children}
    </div>
  );
};
